// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup } from 'react-transition-group'
import LoadingBar from 'react-redux-loading-bar'
import { Switch, Route } from 'react-router-dom'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'
import HeaderPrimary from 'components/HeaderPrimary/HeaderPrimary'
import HeaderMobilePrimary from 'components/HeaderPrimary/HeaderMobilePrimary'
import PageHeader from 'components/PageHeader/PageHeader'
import ForumMenu from 'views/main/Forum/ForumMenu'
import Footer from 'components/Footer/Footer'
import isElementInViewport from 'utilities/isElementInViewport'
import Locale from 'views/main/page/Locale'

const siteImage = siteData.featured_image_url
const siteImageSrcset = siteData.featured_image_srcset

// Redux:
import { getForumData } from 'actions/forum'

class ForumLayout extends React.Component {
	componentDidMount() {
		this.props.getForumData( 'all' )
	}

	render() {
		let { forum, page } = this.props
		let className = 'is-page is-forum with-sidebar',
			pageHeaderTitle = 'Forum'

		if ( forum && forum.title ) {
			pageHeaderTitle += ': ' + forum.title.rendered
		}

		const localesRoutes = siteData.locales ? siteData.locales.map( e => {
			return <Route path={ '/' + e.slug + '/' } component={ Locale } key={ e.slug } />
		}) : null

		return (
			<div className={ className }>
				<HeaderMobilePrimary />

				<div className="main-wrap">
					<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />
					<HeaderPrimary />

					<div className="page-header">
						<div className="-inner">
							<div className="-image">
								<img className="-img -img-fade-a" src={ `${siteData.images_url}forum/desk.jpg` } />
							</div>

							<div className="-text">
								<div className="-title">
									<h1 dangerouslySetInnerHTML={ { __html: pageHeaderTitle } } />
								</div>
							</div>
						</div>
					</div>

					<section className="main">
						<div className="main-inner">
							<div className="primary-wrap">
								<ErrorBoundary>
									<div className="primary-content">
										<TransitionGroup transitionName="page-transition" transitionEnterTimeout={ 500 } transitionLeaveTimeout={ 500 }>
											<Switch>
												{ localesRoutes }

												<Route path="/" component={ Locale } />
											</Switch>
										</TransitionGroup>
									</div>
								</ErrorBoundary>
							</div>

							<div className="secondary-wrap">
								<div className="secondary-content">
									<ForumMenu />

									{ page && page.side_page && page.side_page.image_url &&
										<Link className="-page-link" to={ page.side_page.url }>
											<div className="-image">
												<img src={ page.side_page.image_url } alt={ page.side_page.title } />
											</div>

											<h4 dangerouslySetInnerHTML={ { __html: page.side_page.title } }></h4>

											<div className="-text" dangerouslySetInnerHTML={ { __html: page.side_page.excerpt } }></div>
										</Link>
									}

									{ page && page.side_menu && page.side_menu.content &&
										<div className="-custom">
											{ page.side_menu.heading_url &&
												<h3><a href={ page.side_menu.heading_url } dangerouslySetInnerHTML={ { __html: page.side_menu.heading } }></a></h3>
											||
												<h3 dangerouslySetInnerHTML={ { __html: page.side_menu.heading } }></h3>
											}

											<div dangerouslySetInnerHTML={ { __html: page.side_menu.content } }></div>
										</div>
									}
								</div>
							</div>
						</div>
					</section>
				</div>

				<Footer />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		forum: state.forum.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getForumData( slug ) {
			dispatch( getForumData( slug ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( ForumLayout )



// WEBPACK FOOTER //
// ./views/layouts/main/ForumLayout.jsx